import React from 'react';
import {Link} from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import {Helper} from '../static/helper';
import img from '../images/logo.jpg';

const Footer = () => {
    return (
        <>
            <footer>
                <div style={{ background: Helper.navBarFooterGroundColor }} className="footer max-w-full mx-auto px-4 sm:px-6 bg-gray-100 border-t border-b py-30">

                    {/* Top area: Blocks */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 py-8 md:py-12 border-t border-gray-200 px-4 lg:px-8">

                    {/* 1st block - Logo & Contact */}
                    <div className="flex flex-col items-center lg:items-start">
                        <div className="w-32 sm:w-40 lg:w-48 mb-4">
                            <img alt="Logo Osmose Chiropratique" className="rounded-t w-full" src={img} loading="lazy" />
                        </div>
                        <div className="text-center lg:text-left">
                            <p className="text-gray-300 text-sm mb-2">56B Boulevard Herbet Fournet</p>
                            <p className="text-gray-300 text-sm mb-3">14100 Lisieux</p>
                            <a href="mailto:osmose.chiro@gmail.com" className="text-white text-sm hover:underline">osmose.chiro@gmail.com</a>
                        </div>
                    </div>

                    {/* 2nd block - Horaires */}
                    <div className="text-center sm:text-left">
                        <h6 className="text-lg lg:text-xl text-white font-bold mb-4">Horaires</h6>
                        <div className="text-sm text-gray-300 space-y-2">
                            <div className="flex justify-center sm:justify-start gap-2">
                                <span className="font-semibold text-white">Lun - Sam:</span>
                                <span>9h - 19h30</span>
                            </div>
                            <div className="flex justify-center sm:justify-start gap-2">
                                <span className="font-semibold text-white">Dim:</span>
                                <span>Fermé</span>
                            </div>
                        </div>
                        <div className="mt-4 space-y-2">
                            <p className="text-white font-semibold text-sm">Emilie Gouache</p>
                            <a href="tel:+33678332375" className="text-gray-300 text-sm hover:text-white hover:underline block">06 78 33 23 75</a>
                            <p className="text-white font-semibold text-sm mt-2">Alexis Moulin</p>
                            <a href="tel:+33626220251" className="text-gray-300 text-sm hover:text-white hover:underline block">06 26 22 02 51</a>
                        </div>
                    </div>

                    {/* 3rd block - Navigation */}
                    <div className="text-center sm:text-left">
                        <h6 className="text-lg lg:text-xl font-bold mb-4 text-white">Navigation</h6>
                        <ul className="text-sm space-y-2">
                            <li>
                                <HashLink to="/Chiropraxie" className="text-gray-300 hover:text-white transition duration-200">Qu'est ce que la chiropraxie ?</HashLink>
                            </li>
                            <li>
                                <Link to="/ConsultationQui" className="text-gray-300 hover:text-white transition duration-200">Qui peut consulter ?</Link>
                            </li>
                            <li>
                                <Link to="/ConsultationPourquoi" className="text-gray-300 hover:text-white transition duration-200">Pourquoi consulter ?</Link>
                            </li>
                            <li>
                                <Link to="/Praticiens" className="text-gray-300 hover:text-white transition duration-200">Nos chiropracteurs</Link>
                            </li>
                            <li>
                                <Link to="/Tarifs" className="text-gray-300 hover:text-white transition duration-200">Tarifs</Link>
                            </li>
                            <li>
                                <Link to="/contact" className="text-gray-300 hover:text-white transition duration-200">Contact</Link>
                            </li>
                        </ul>
                    </div>

                    {/* 4th block - RDV */}
                    <div className="text-center sm:text-left">
                        <h6 className="text-lg lg:text-xl font-bold mb-4 text-white">Prendre rendez-vous</h6>
                        <p className="text-gray-300 text-sm mb-4">Réservez votre consultation en ligne facilement.</p>
                        <a
                            href={Helper.urlReservation}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ background: Helper.contentLetterColor }}
                            className="inline-block text-gray-900 font-semibold px-6 py-3 rounded-lg hover:opacity-90 transition-opacity"
                            aria-label="Réserver une consultation en ligne"
                        >
                            Réserver en ligne
                        </a>
                        <div className="mt-6">
                            <p className="text-white font-semibold text-sm mb-2">Tarifs</p>
                            <p className="text-gray-300 text-sm">1ère consultation : 70€</p>
                            <p className="text-gray-300 text-sm">Suivi : 65€</p>
                            <p className="text-gray-300 text-sm">Étudiants : 55€</p>
                        </div>
                    </div>

                    </div>

                    <div className="flex flex-wrap items-center md:justify-between justify-center mx-auto px-4 border-t border-gray-700 pt-6">
                        <div className="w-full md:w-4/12 px-4 mx-auto text-center py-2">
                            <div className="text-sm text-gray-400 py-1">
                                © {new Date().getFullYear()} Osmose Chiropratique. Tous droits réservés.
                            </div>
                        </div>
                    </div>

                </div>

            </footer>
        </>
    )
}
export default Footer;
